(function () {
  function openCookiePreferences(event) {
    if (event) event.preventDefault();
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.showPreferences === "function") {
      privacy.showPreferences();
      return;
    }
    if (privacy && typeof privacy.showConsentBanner === "function") {
      privacy.showConsentBanner();
      return;
    }
    var prefs = document.getElementById("shopify-pc__prefs");
    var banner = document.getElementById("shopify-pc__banner");
    if (prefs) {
      prefs.hidden = false;
      prefs.style.display = "block";
      return;
    }
    if (banner) {
      banner.hidden = false;
      banner.style.display = "block";
    }
  }

  function bindCookieLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      var label = (link.textContent || "").replace(/\s+/g, " ").trim();
      if (!/cookie[-\s]?setting/i.test(label)) return;
      link.addEventListener("click", openCookiePreferences);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindCookieLinks);
  } else {
    bindCookieLinks();
  }
})();
